webpackJsonp([273999271458146],{

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Cart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _cartModule = __webpack_require__(73);
	
	var _cartModule2 = _interopRequireDefault(_cartModule);
	
	var _Table = __webpack_require__(66);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _FAQ = __webpack_require__(42);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_cartModule2.default);
	var propTypes = {};
	
	function Cart() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: cx('cart') },
	      _react2.default.createElement(
	        'header',
	        { className: cx('header') },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Your Cart'
	        ),
	        _react2.default.createElement('div', { className: cx('header-underline') })
	      ),
	      _react2.default.createElement(_Table2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: cx('checkout') },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/checkout' },
	          _react2.default.createElement(
	            'button',
	            { className: cx('button') },
	            'Check Out'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_FAQ2.default, { type: 'cart' })
	  );
	}
	Cart.displayName = 'Cart';
	Cart.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.Table = Table;
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reselect = __webpack_require__(11);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _cartModule = __webpack_require__(73);
	
	var _cartModule2 = _interopRequireDefault(_cartModule);
	
	var _redux = __webpack_require__(19);
	
	var _Selector = __webpack_require__(106);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var cx = _bind2.default.bind(_cartModule2.default);
	var propTypes = {
	  clickOnRemove: _propTypes2.default.func.isRequired,
	  changeQuantity: _propTypes2.default.func,
	  editable: _propTypes2.default.bool,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    alt: _propTypes2.default.string,
	    quantity: _propTypes2.default.number,
	    size: _propTypes2.default.number,
	    sku: _propTypes2.default.string,
	    src: _propTypes2.default.string,
	    srcSet: _propTypes2.default.string,
	    title: _propTypes2.default.string
	  })),
	  total: _propTypes2.default.shape({
	    amount: _propTypes2.default.string
	  })
	};
	
	var mapStateToProps = (0, _reselect.createSelector)(_redux.itemsSelector, _redux.totalSelector, function (items, total) {
	  return {
	    total: total,
	    items: items.map(function (_ref) {
	      var _ref$meta = _ref.meta,
	          meta = _ref$meta === undefined ? {} : _ref$meta,
	          item = _objectWithoutProperties(_ref, ['meta']);
	
	      return _extends(item, meta);
	    })
	  };
	});
	
	var mapDispatchToProps = { clickOnRemove: _redux.clickOnRemove, changeQuantity: _redux.changeQuantity };
	
	function Table(_ref2) {
	  var clickOnRemove = _ref2.clickOnRemove,
	      changeQuantity = _ref2.changeQuantity,
	      _ref2$items = _ref2.items,
	      items = _ref2$items === undefined ? [] : _ref2$items,
	      _ref2$total = _ref2.total,
	      total = _ref2$total === undefined ? {} : _ref2$total,
	      _ref2$editable = _ref2.editable,
	      editable = _ref2$editable === undefined ? true : _ref2$editable;
	
	  return _react2.default.createElement(
	    'div',
	    { className: cx('table') },
	    _react2.default.createElement(
	      'div',
	      { className: cx('table-cell-first', 'table-first') },
	      'Item'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: cx('table-cell') },
	      'Price'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: cx('table-cell') },
	      'Quantity'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: cx('table-cell') },
	      'Total'
	    ),
	    items.reduce(function (a, _ref3) {
	      var title = _ref3.title,
	          sku = _ref3.sku,
	          _ref3$image = _ref3.image,
	          image = _ref3$image === undefined ? {} : _ref3$image,
	          price = _ref3.price,
	          size = _ref3.size,
	          quantity = _ref3.quantity;
	
	      a.push(_react2.default.createElement(
	        'div',
	        { className: cx('table-cell-first', 'details'), key: sku + sku },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/women/shoes/' + sku },
	            _react2.default.createElement('img', {
	              alt: image.alt,
	              className: cx('details-img'),
	              src: image.src,
	              srcSet: image.srcSet
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: cx('details-info') },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/women/shoes/' + sku },
	            _react2.default.createElement(
	              'div',
	              { className: cx('product-name') },
	              title
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: cx('size-info') },
	            'Size: ',
	            _react2.default.createElement(
	              'span',
	              { className: cx('size-selected') },
	              size
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            editable ? _react2.default.createElement(
	              'button',
	              {
	                className: cx('remove'),
	                onClick: function onClick() {
	                  return clickOnRemove(sku);
	                }
	              },
	              'Remove'
	            ) : null
	          )
	        )
	      ));
	      a.push(_react2.default.createElement(
	        'div',
	        { className: cx('table-cell', 'price'), key: sku + 'price' },
	        '$',
	        price.amount
	      ));
	      a.push(editable ? _react2.default.createElement(
	        'div',
	        {
	          className: cx('table-cell', 'quantity'),
	          key: sku + 'quantity'
	        },
	        _react2.default.createElement(_Selector2.default, {
	          className: cx('quantity-selector', 'selector'),
	          value: quantity,
	          onChange: function onChange(_ref4) {
	            var value = _ref4.value;
	            return changeQuantity({ sku: sku, value: value });
	          }
	        })
	      ) : _react2.default.createElement(
	        'div',
	        {
	          className: cx('table-cell', 'quantity-static'),
	          key: sku + 'quantityt'
	        },
	        quantity
	      ));
	      a.push(_react2.default.createElement(
	        'div',
	        { className: cx('table-cell', 'total'), key: sku + 'total' },
	        '$',
	        _lodash2.default.round(price.amount * quantity, 2)
	      ));
	      return a;
	    }, []),
	    _react2.default.createElement(
	      'div',
	      { className: cx('table-cell', 'table-total') },
	      'TOTAL'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: cx('table-cell', 'table-sum') },
	      '$',
	      total.amount
	    )
	  );
	}
	Table.displayName = 'Table';
	Table.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Table);

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cart":"_2jHUlCRUu54bHSkQlOTZoQ","header":"_3_VMjVdBCFJuSqebTEaa3j","header-underline":"_2dbi7yuku1ZocP6-AnyXC0","table":"_3QqBrJc-LlG8U0Tf5wG1mg","table-cell-first":"_2p56EoqVpMQ8d1fdYV5dDV","table-cell":"_2Y2erKjQ-qWbMLsRQ3moGT","details":"BG4uJCnGZAyO3hjVA16fE","details-img":"_1t39Mk3QDnyS1AHg7bb-U_","details-info":"_3w-siqWRCpDtKxNXqEEr8O","product-name":"SaqerZbR5-9g7aUpp8EEH","remove":"_2OrpdZwZEJZ7YX6IN54S8L","size-info":"_3MwBlewdkt116iuKp3iNDx","size-selected":"_2SbOZRlCN2vW_awr5_cBMo","price":"Rhc60gdNnSLgKdICSRgkD","total":"_29MVDfyKb6mBDBei8Du1Ku","table-total":"PuPJ2hhr89cISg64InZNt","quantity":"_3vpa6zqra87otm2OuCwVJc","quantity-static":"_3aVBc7iOWMHRxZx5_8lrMe","table-sum":"_1B4_bPLBY_mN9MREuSSw7E","checkout":"_2n9Ju7y02dDK-pUrNzQGvK","button":"hENkEJkL1OnQXm7fvdRPu"};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Cart = __webpack_require__(206);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cart).default;
	  }
	});
	
	var _Table = __webpack_require__(66);
	
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Table).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Cart = __webpack_require__(207);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cart).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cart-jsx-610fc212ed418f620e80.js